export default __webpack_public_path__ + "assets/images/4996dacb954eeef88a93aed3b6d6d5fd.svg";